var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNewWindow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 17.975v-.136c1.174-.49 2-1.649 2-3V6.25A3.25 3.25 0 0 0 17.75 3h-8.5a3.251 3.251 0 0 0-3.093 2.25h-.201c-.912 0-1.688.321-2.222.954C3.216 6.817 3 7.634 3 8.5v8.75c0 1.06.383 2.014 1.11 2.7.726.683 1.733 1.045 2.89 1.045h3.92l4.076.005h.002c.976.005 1.943-.2 2.693-.68.78-.5 1.309-1.295 1.309-2.345ZM5.956 6.75H6v8.088a3.25 3.25 0 0 0 3.25 3.25h8.246c-.032.418-.242.73-.614.968-.433.278-1.09.448-1.878.444H15l-4.082-.005H7c-.843 0-1.46-.26-1.86-.637-.398-.374-.64-.918-.64-1.608V8.5c0-.635.16-1.067.38-1.329.205-.242.532-.421 1.076-.421Zm6.066-.25h4.728a.75.75 0 0 1 .75.75v4.729a.75.75 0 0 1-1.5 0V9.06l-5.22 5.22a.75.75 0 1 1-1.06-1.061L14.94 8h-2.918a.75.75 0 1 1 0-1.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewWindow);
export default __webpack_public_path__ + "static/media/ic-new-window.e32fab2bf8cbc04c31f445d43f5ed05b.svg";
export { ForwardRef as ReactComponent };